import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

let state = {
  alerts: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
